/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { apisCreateApi } from "../../funcs/apisCreateApi.js";
import * as components from "../../models/components/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: components.V2ApisCreateApiRequestBody$inboundSchema,
};

export const tool$apisCreateApi: ToolDefinition<typeof args> = {
  name: "apis-create-api",
  description: ``,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await apisCreateApi(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
